import React from 'react'
import { Card, Col, Form, message, Row, Space, Typography } from 'antd'
const { Text } = Typography
import moment from 'moment/moment'
import { copyTextToClipboard, getTimeZoneLabel } from '../../../../helpers/text'

const URL_WEBSOCKET = process.env.REACT_APP_EQUIPAMENTO_WEBSOCKET_URL;
const PORT_WEBSOCKET = process.env.REACT_APP_EQUIPAMENTO_WEBSOCKET_PORT;

const T4 = ({ item }) => {
  const { configuracao, numero_serial_rep, ultimo_nsr_rep_p, token } = item

  const handleTokenCopyClick = (target) => {
    copyTextToClipboard(target.innerText).then(() => {
      message.info('Token copiado para área de transferência.')
    })
  }

  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Card title="Dados de comunicação">
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item label="Número de série">{numero_serial_rep}</Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Último NSR REP-P">{ultimo_nsr_rep_p}</Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            {URL_WEBSOCKET && <div>
                <p style={{ fontWeight: 'bold' }}>URL de Conexão</p>
                <Typography.Text copyable>{URL_WEBSOCKET}</Typography.Text>
              </div>}
          </Col>
          <Col xs={24} md={12}>
            {PORT_WEBSOCKET && <div>
                <p style={{ fontWeight: 'bold' }}>Porta</p>
                <Typography.Text copyable>{PORT_WEBSOCKET}</Typography.Text>
              </div>}
          </Col>
        </Row>
      </Card>
      <Card title="Outros">
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item label="Token">
              <Text
                onClick={({ target }) => handleTokenCopyClick(target)}
                style={{ cursor: 'pointer' }}
              >
                {token}
              </Text>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Fuso horário">
              {getTimeZoneLabel[configuracao.fuso_horario]}
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item label="Data e horário">
              {configuracao.data_hora
                ? moment(configuracao.data_hora).format('DD/MM/YYYY HH:mm')
                : '-'}
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Space>
  )
}

export default T4;
